// extracted by mini-css-extract-plugin
export var text = "_bn-0";